import { FC } from 'react';

import { FormTabs } from 'components';
import { Stack } from 'libs/ui';
import { ClientMainInfo } from 'modules/client/common/components/ClientMainInfo';
import {
  CountryRiskProvider,
  CountryRiskRole,
} from 'modules/client/common/feature';
import { RepresentativeSectionsProps } from 'modules/client/representativeClient/components/RepresentativeSections/types';
import { useRepresentativeSections } from 'modules/client/representativeClient/components/RepresentativeSections/useRepresentativeSections';

export const RepresentativeSections: FC<RepresentativeSectionsProps> = ({
  countryRiskAt,
  ...props
}) => {
  const { tabs, info } = useRepresentativeSections(props);

  return (
    <CountryRiskProvider
      at={countryRiskAt}
      role={CountryRiskRole.ClientRepresentative}
    >
      <Stack spacing={36}>
        {info && <ClientMainInfo info={info} />}

        <FormTabs tabs={tabs} />
      </Stack>
    </CountryRiskProvider>
  );
};
